import React from 'react';
import NavBar from '@components/navigation/NavBar';
import NavBasketMenu from '@components/navigation/NavBasketMenu';
import NavMenu from '@components/navigation/NavMenu';

const Nav: React.FC = () => (
  <>
    <NavBar />
    <NavMenu />
    <NavBasketMenu />
  </>
);

export default Nav;
